import React from "react";
import Icon from "../../../components/AppIcon";

const ValidationPanel = ({ validationStatus, matchedData }) => {
  const getStatusConfig = () => {
    switch (validationStatus) {
      case "success":
        return {
          icon: "CheckCircle2",
          color: "text-success",
          bgColor: "bg-success/10",
          borderColor: "border-success/20",
          title: "Customer Pre-Qualified",
          message: "Customer details matched with database records",
        };
      case "error":
        return {
          icon: "XCircle",
          color: "text-error",
          bgColor: "bg-error/10",
          borderColor: "border-error/20",
          title: "Validation Failed",
          message: "Customer not found in pre-qualified database",
        };
      case "warning":
        return {
          icon: "AlertTriangle",
          color: "text-warning",
          bgColor: "bg-warning/10",
          borderColor: "border-warning/20",
          title: "Partial Match",
          message: "Some details do not match database records",
        };
      default:
        return {
          icon: "Info",
          color: "text-muted-foreground",
          bgColor: "bg-muted",
          borderColor: "border-border",
          title: "Awaiting Validation",
          message: "Complete all fields to validate customer",
        };
    }
  };

  const config = getStatusConfig();

  return (
    <div
      className={`rounded-lg border ${config?.borderColor} ${config?.bgColor} p-4 md:p-6`}
    >
      <div className="flex items-start gap-3 md:gap-4">
        <div
          className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full ${config?.bgColor} flex items-center justify-center`}
        >
          <Icon name={config?.icon} size={24} className={config?.color} />
        </div>

        <div className="flex-1 min-w-0">
          <h3
            className={`text-base md:text-lg font-semibold ${config?.color} mb-1`}
          >
            {config?.title}
          </h3>
          <p className="text-sm text-muted-foreground mb-3">
            {config?.message}
          </p>

          {validationStatus === "success" && matchedData && (
            <div className="bg-card rounded-lg p-3 md:p-4 space-y-2">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
                <div>
                  <span className="text-muted-foreground">Cluster:</span>
                  <span className="ml-2 font-medium text-foreground">
                    {matchedData?.cluster}
                  </span>
                </div>
                <div>
                  <span className="text-muted-foreground">Region:</span>
                  <span className="ml-2 font-medium text-foreground">
                    {matchedData?.region}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ValidationPanel;
